import React, { useEffect, useState } from "react";
import "./style.scss";
// import SidebarLogo from "../../assets/images/sidebarLogo.png";
// import SidebarLogo from "../../assets/images/cultiva.png";
// import SidebarLogo from "../../assets/images/Logo.svg";
import SidebarLogo from "../../assets/images/cultivate-verticla-logo.svg";

import PodcastImg from "../../assets/images/sidebar/podcast.png";
import CmsImg from "../../assets/images/sidebar/cms.png";
import noteImg from "../../assets/images/sidebar/note.png";
import notificationImg from "../../assets/images/sidebar/notification-bing.png";
import messageImg from "../../assets/images/sidebar/message-question.png";
import SubscriptionImg from "../../assets/images/sidebar/subscription.png";
import TenantImg from "../../assets/images/sidebar/tenant.png";
import DashboardImg from "../../assets/images/sidebar/dashboard.png";
import AdvertisingImg from "../../assets/images/sidebar/advertising.png";
import { ReactComponent as Logout } from "../../assets/images/Power.svg";
import { ReactComponent as Password } from "../../assets/images/lock.svg";
import { DownOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar, Dropdown, Layout, Menu, Space, theme } from "antd";
import { Link, Navigate, useLocation, useNavigate } from "react-router";
import ConfirmModal from "../../components/common/alert-popup";
import ChangePasswordModal from "../../modules/auth/change-password/ChangePasswordModal";
import { urlConstant } from "../../constants/urlConstant";
import ViewProfileDetails from "../../modules/auth/view-profile/ViewProfileDetails";
import { DELETE } from "../../services/api";
import { toast } from "react-toastify";
const { Header, Content, Sider } = Layout;

function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}
<img src="" alt="" />;
const items = [
  getItem(
    <Link to={"/dashboard"}>Dashboard</Link>,
    "1",
    <img src={DashboardImg} alt={DashboardImg} />
  ),
  getItem(
    <Link to={"/tenant-mgmnt"}>Tenant Management</Link>,
    "2",
    <img src={TenantImg} alt={TenantImg} />
  ),
  getItem(
    <Link to={"/user-activity"}>User Activity Log</Link>,
    "13",
    <img src={noteImg} alt={noteImg} />
  ),
  getItem(
    "Podcast Management",
    "sub1",
    <img src={PodcastImg} alt={PodcastImg} />,
    [
      getItem(<Link to={"/manage-podcast"}>Manage Podcast</Link>, "3"),
      getItem(<Link to={"/manage-audio"}>Manage Audio</Link>, "15"),
      getItem(<Link to={"/manage-category"}>Manage Category</Link>, "4"),
      getItem(
        <Link to={"/manage-home-category"}>Manage Home Category</Link>,
        "5"
      ),
      
      getItem(<Link to={"/manage-authors"}>Manage Authors</Link>, "14"),
      getItem(
        <Link to={"/manage-celebrity"}>Manage Celebrity</Link>,
        "7"
        // <img src={CelebrityImg} alt={CelebrityImg} />
      ),
    ]
  ),
  getItem(
    <Link to={"/advertising"}>Advertising</Link>,
    "8",
    <img src={AdvertisingImg} alt={AdvertisingImg} />
  ),
  getItem(
    <Link to={"/cms-mgmnt"}>CMS Management</Link>,
    "9",
    <img src={CmsImg} alt={CmsImg} />
  ),
  getItem(
    <Link to={"/manage-subscription"}>Manage Subscription</Link>,
    "10",
    <img src={SubscriptionImg} alt={SubscriptionImg} />
  ),
  getItem(
    <Link to={"/queries"}>Queries</Link>,
    "11",
    <img src={messageImg} alt={messageImg} />
  ),
  getItem(
    <Link to={"/notification"}>Notification</Link>,
    "12",
    <img src={notificationImg} alt={notificationImg} />
  ),
];
const DashboardView = ({ children = <></> }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [activeMenu, setActiveMenu] = useState("Dashboard");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    open: false,
    actionType: "",
  });
  const [viewProfile, setViewProfile] = useState(false);
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();
  const [changePassword, setChangePassword] = useState(false);

  const [menuHeight, setMenuHeight] = useState("100vh");

  useEffect(() => {
    const updateHeight = () => {
      const vh = window.innerHeight;

      if (vh < 600) {
        setMenuHeight("70vh"); // or any smaller value
      } else {
        setMenuHeight("100vh");
      }
    };

    updateHeight(); // initial run
    window.addEventListener("resize", updateHeight); // update on resize

    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  const showModal = (actionType) => {
    setModalConfig({ open: true, actionType });
  };

  const closeModal = (actionType) => {
    setModalConfig({ open: false, actionType });
  };

  const handleConfirm = async () => {
    let response;
    try {
      response = await DELETE(`/admin/auth/session`);

      if (response?.data?.code === 200) {
        localStorage.clear();
        navigate(urlConstant?.bashRoute);
        closeModal();
      } else {
        toast.error(response?.data.message);
      }
    } catch (error) {
      toast.error(response?.data.message);
    }
  };

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const pathToKeyMap = {
    "/dashboard": "1",
    "/tenant-mgmnt": "2",
    "/manage-podcast": "3",
    "/manage-category": "4",
    "/manage-home-category": "5",
    "/manage-celebrity": "7",
    "/advertising": "8",
    "/cms-mgmnt": "9",
    "/manage-subscription": "10",
    "/queries": "11",
    "/notification": "12",
    "/user-activity": "13",
    "/manage-authors": "14",
    "/manage-audio": "15",
  };

  const location = useLocation();
  const [selectedKey, setSelectedKey] = useState("1");

  // useEffect(() => {
  //   const path = location.pathname;
  //   const key = pathToKeyMap[path];
  //   if (key) {
  //     setSelectedKey(key);

  //     // Get active label when page reloads
  //     const selectedItem = items
  //       .flatMap((item) => [item, ...(item.children || [])])
  //       .find((item) => item.key === key);

  //     if (selectedItem) {
  //       const label = typeof selectedItem.label === "object"
  //         ? selectedItem.label?.props?.children
  //         : selectedItem.label;

  //       setActiveMenu(label);
  //     }
  //   }
  // }, [location.pathname]);

  // useEffect(() => {
  //   const path = location.pathname;

  //   // Find a key whose path is a prefix of the current location
  //   const matchedPath = Object.keys(pathToKeyMap).find((basePath) =>
  //     path.startsWith(basePath)
  //   );

  //   const key = pathToKeyMap[matchedPath];

  //   if (key) {
  //     setSelectedKey(key);

  //     // Get active label when page reloads
  //     const selectedItem = items
  //       .flatMap((item) => [item, ...(item.children || [])])
  //       .find((item) => item.key === key);

  //     if (selectedItem) {
  //       const label =
  //         typeof selectedItem.label === "object"
  //           ? selectedItem.label?.props?.children
  //           : selectedItem.label;

  //       setActiveMenu(label);
  //     }
  //   }
  // }, [location.pathname]);

  // useEffect(() => {
  //   const path = location.pathname;
  //   const matchedPath = Object.keys(pathToKeyMap).find((basePath) =>
  //     path.startsWith(basePath)
  //   );

  //   const key = pathToKeyMap[matchedPath];

  //   if (key) {
  //     setSelectedKey(key);
  //     const selectedItem = items
  //       .flatMap((item) => [item, ...(item.children || [])])
  //       .find((item) => item.key === key);

  //     if (selectedItem) {
  //       const label = typeof selectedItem.label === "object"
  //         ? selectedItem.label?.props?.children
  //         : selectedItem.label;

  //       setActiveMenu(label);
  //     }
  //   }
  // }, [location.pathname]);
  const [openKeys, setOpenKeys] = useState([]);

  useEffect(() => {
    const path = location.pathname;
    const matchedPath = Object.keys(pathToKeyMap).find((basePath) =>
      path.startsWith(basePath)
    );

    const key = pathToKeyMap[matchedPath];

    if (key) {
      setSelectedKey(key);

      // Check which submenu it belongs to
      const parent = items.find(
        (item) =>
          item.children && item.children.some((child) => child.key === key)
      );

      if (parent) {
        setOpenKeys([parent.key]);
      } else {
        setOpenKeys([]);
      }

      const selectedItem = items
        .flatMap((item) => [item, ...(item.children || [])])
        .find((item) => item.key === key);

      if (selectedItem) {
        const label =
          typeof selectedItem.label === "object"
            ? selectedItem.label?.props?.children
            : selectedItem.label;

        setActiveMenu(label);
      }
    }
  }, [location.pathname]);

  const handleMenuSelect = ({ key }) => {
    const selectedItem = items
      .flatMap((item) => [item, ...(item.children || [])])
      .find((item) => item.key === key);

    if (selectedItem) {
      // If the label is a React element (like <Link>), you can extract its children:
      const label =
        typeof selectedItem.label === "object"
          ? selectedItem.label?.props?.children
          : selectedItem.label;

      setActiveMenu(label); // or selectedItem.label if you don't need plain text
    }
  };

  const handleMenuClick = ({ key }) => {
    setDropdownOpen(false);

    if (key === "changePassword") {
      setChangePassword(true);
    } else if (key === "logout") {
      showModal("logout");
    } else if (key === "viewProfile") {
      setViewProfile(true);
    }
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="changePassword" icon={<Password />}>
        Change Password
      </Menu.Item>
      <Menu.Item key="viewProfile" icon={<Password />}>
        View Profile
      </Menu.Item>
      <Menu.Item key="logout" icon={<Logout />} className="logoutBtn">
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Layout
        style={{
          minHeight: "100vh",
        }}
        className="customLayout"
      >
        <Sider
          collapsible
          collapsed={collapsed}
          onCollapse={(value) => setCollapsed(value)}
          width={260}
          style={{
            position: "fixed",
            height: "100vh",
            left: 0,
            top: 0,
            bottom: 0,
            zIndex: 1000,
            background: "linear-gradient(180deg, #45AE51 0%, #249B6C 100%)",
          }}

          // position: relative;
          // left: 20px;
        >
          <div className={`sidebarLogo ${collapsed ? "collapsed" : ""}`}>
            <img src={SidebarLogo} alt={SidebarLogo} />
          </div>
          <Menu
            theme="dark"
            selectedKeys={[selectedKey]}
            openKeys={openKeys}
            onOpenChange={(keys) => setOpenKeys(keys)}
            mode="inline"
            items={items}
            onSelect={handleMenuSelect}
            style={{
              background: "transparent",
              height: menuHeight,
              overflowY: "auto",
              transition: "height 0.3s ease",
            }}
          />
        </Sider>
        <Layout
          style={{
            marginLeft: collapsed ? 80 : 260,
            transition: "margin-left 0.2s",
          }}
        >
          <Header
            style={{
              background: colorBgContainer,
              padding: 0,
            }}
          >
            <div className="headerBx">
              <p className="headerTitle">{activeMenu}</p>
              <Dropdown
                overlay={menu}
                trigger={["click"]}
                placement="bottomRight"
                open={dropdownOpen}
                onOpenChange={(flag) => setDropdownOpen(flag)}
              >
                <div>
                  <Space gap={2}>
                    <Avatar size={40} icon={<UserOutlined />} />
                    <DownOutlined />
                  </Space>
                </div>
              </Dropdown>
            </div>
          </Header>
          <Content>
            <div
              style={{
                padding: "30px 50px 50px  30px",
              }}
            >
              {children}
            </div>
          </Content>
        </Layout>
      </Layout>
      <ConfirmModal
        open={modalConfig.open}
        onClose={closeModal}
        onConfirm={handleConfirm}
        actionType={modalConfig.actionType}
      />
      <ChangePasswordModal
        open={changePassword}
        onClose={() => setChangePassword(false)}
        onConfirm={handleConfirm}
      />
      <ViewProfileDetails
        open={viewProfile}
        onClose={() => setViewProfile(false)}
        userData={{ name: "test" }}
      />
    </>
  );
};
export default DashboardView;
